import { DefaultRootState, useDispatch, useSelector } from 'react-redux';
import { useEffect, useState, useCallback, useRef } from 'react';
import React from 'react';
import useSlotListStyles from './useSlotListStyles';
import {
    Box,
    Button,
    IconButton,
    ListItemSecondaryAction,
    Typography,
    withStyles,
} from '@material-ui/core';
import { getActiveInitRoute, getPermissions } from '../../../utils/permissions';
import usePagination from '../../../hooks/usePagination';
import {
    getAllTeamLeads,
    getTeamLeadFleets,
} from '../../../store/actions/cmActionCreator';
import {
    CM_STATUS_TYPES_MAPPING,
    convertRStoAmount,
    getColorBasedOnValue,
    TL_CLASS_TYPE_MAPPING,
} from '../../cluster-management/helper.cm';
import { preProcessPayload, SLOT_TYPE_CLASS_TYPE_MAPPING } from './slot.helper';
import { replaceWithUnderscore } from '../../control-center/helper';
import useCommonStyles from '../../../components/UI/CommonStyles';
import clsx from 'clsx';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CustomDropdown from '../../../components/Dropdown';
import moment from 'moment';
import {
    formatCurrencyV1,
    currencyFormatWithoutDecimal,
    FormatTime,
    BBNOW_VENDOR_ID,
} from '../../../utils/appHelper';
import { fetchSlotfilterList } from '../../../store/actions/settingsActionCreator';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { SlotIcon } from './utility.component.slot';
const useSlotList = (props: any) => {
    //values
    const containerRef = React.useRef<HTMLElement>(null);
    const initialPage = 0; // Start on page 0 (0-based index)
    const initialPageSize = 25; // Show 25 rows per page
    const initialActiveFilterCard = {
        type: 'Total',
        subType: '',
    }; // Example filter card
    const initialFilterValues = {}; // Example filter values
    const initialSearchText = ''; // Example search text
    const initialPayload = {
        pageNo: initialPage,
        pageSize: initialPageSize,
        searchText: '',
        filters: {
            ...initialFilterValues,
            ...props?.externalFiltered,
        },
        dedicatedSlotGroupFilter: 'ALL', // ALL/PEAK/SHORTAGE
        startDate: moment().startOf('week').format('YYYY-MM-DD'),
        endDate: moment().endOf('week').format('YYYY-MM-DD'),
        ...props?.externalFiltered,
    };

    //State values
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [containerHeight, setContainerHeight] = useState(0);
    const [teamLeadDetails, setTeamLeadDetails] = useState<any>({});
    const [tlAttendanceModalOpen, setTlAttendanceModalOpen] =
        useState<boolean>(false); // State to control the modal open/close
    const [openDetailModal, setOpenDetailModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isDeleteModalOpen, toggleDeleteModal] = useState(false);
    const [deleteLoading, toggleDeleteLoading] = useState(false);
    const [openEditCapacityModal, setOpenEditCapacityModal] = useState(false);
    const [selectedCapacityRow, setSelectedCapacityRow] = useState(null);

    const openEditCapacityModalHandler = (row: any) => {
        setSelectedCapacityRow(row);
        setOpenEditCapacityModal(true);
    };
    const closeEditCapacityModalHandler = () => {
        setSelectedCapacityRow(null);
        setOpenEditCapacityModal(false);
        fetchSlotsData();
    };

    const openDetailModalHandler = (row: any) => {
        setSelectedRow(row);
        setOpenDetailModal(true);
    };
    const closeDetailModalHandler = () => {
        setSelectedRow(null);
        setOpenDetailModal(false);
        fetchSlotsData();
    };
    //hooks
    const {
        pagination,
        handleChangePage,
        handleChangeRowsPerPage,
        activeFilterCard,
        filterValues,
        searchTextValue,
        payload,
        onFilterApplied,
        onBackendSearch,
        onSearchTextChange,
        onRemoveAll,
        handleActiveFilterCard,
        setFilterValues,
    } = usePagination(
        initialPage,
        initialPageSize,
        initialActiveFilterCard,
        initialFilterValues,
        initialSearchText,
        initialPayload,
    );
    const { user, staff, settings } = useSelector(
        (store: DefaultRootState | any) => store || {},
    );
    const isBBNowVendor = BBNOW_VENDOR_ID?.includes(user?.role) ?? false;

    console.log('slotsList', settings);
    const slotList: any = settings?.slotsList;

    const dispatch = useDispatch();

    // Memoize the dispatch function to prevent recreating it on every render
    const dispatchGetSlots = useCallback(
        (data: any, onSuccess: Function, onError: Function) => {
            dispatch(fetchSlotfilterList(data, onSuccess, onError));
        },
        [dispatch],
    );
    const currentOrgId = settings?.basicDetails?.id || user?.orgId;

    const styles: any = useSlotListStyles({
        containerHeight: containerHeight,
    });
    const commonStyles: any = useCommonStyles();

    // Create a ref to track the initial render
    const initialRender = useRef(true);

    useEffect(() => {}, [user?.configs, props?.history]);

    useEffect(() => {
        if (!!containerRef?.current?.offsetHeight && !containerHeight) {
            const height = containerRef.current.offsetHeight;
            setContainerHeight(height);
        }
    }, [containerRef?.current?.offsetHeight, containerHeight]);

    // Memoize the API call function
    const fetchSlotsData = useCallback(() => {
        setIsLoading(true);
        let preProceedPayload = preProcessPayload(payload);
        dispatchGetSlots(
            preProceedPayload,
            (data: any) => {
                //setTeamLeads(data);
                setIsLoading(false);
            },
            (error: any) => {
                setIsLoading(false);
            },
        );
    }, [payload, dispatchGetSlots]);

    useEffect(() => {
        // Add debounce to prevent rapid API calls when payload changes
        const timer = setTimeout(() => {
            fetchSlotsData();
        }, 300);

        return () => clearTimeout(timer);
    }, [fetchSlotsData]);

    useEffect(() => {}, []);

    const prepareFilterCard = (card: any) => {
        switch (card?.type) {
            default:
                return (
                    <>
                        <Typography className={styles.cardHeader}>
                            {card?.name}
                        </Typography>
                        <Typography className={styles.cardSubHeader}>
                            {slotList?.[card?.valueMappingKey] ?? '0'}
                        </Typography>
                    </>
                );
        }
    };

    const actionDropDown = (val: any) => {
        let options: any = [];
        const detailsView = {
            item: 'View',
            onSuccess: (e: any) => {
                e?.stopPropagation();
                e?.preventDefault();
                if (!!val?.taggedRiderDetails?.contactNumber) {
                    handleSingleRidersPage(val);
                }
            },
            disabled: !val?.taggedRiderDetails?.contactNumber,
        };
        options = [detailsView];
        return (
            <CustomDropdown
                title={'Options'}
                options={options}
                optionStyles={null}
                expandMoreButtonStyles={null}
                styledMenuItemStyles={commonStyles.menu}
                buttonProps={null}
                buttonStyles={null}
            />
        );
    };
    const handleRowClick = (e: any, val: any) => {};
    const getColumnComponentValue = (
        row: any,
        column: any,
        handleAction: any,
    ) => {
        let compValue: any = (
            <Box>
                <Typography className={styles.tableValue}>
                    {row?.[column?.valueKey] ?? '-/-'}
                </Typography>
            </Box>
        );
        const orderStatus: any = row?.slotType
            ?.toUpperCase()
            ?.replace(' ', '_')
            ?.trim();

        let chipOrderClass: any =
            styles?.[`${SLOT_TYPE_CLASS_TYPE_MAPPING?.[orderStatus]}`];
        switch (column?.mappingKey) {
            case 'date':
                compValue = (
                    <Box>
                        <Typography className={styles.tableValue}>
                            {row?.displayDateMainText ?? '-'}
                        </Typography>
                        <Typography className={styles.tableSubValue}>
                            {row?.displayDateSubText ?? '-'}
                        </Typography>
                    </Box>
                );
                break;
            case 'segment':
                compValue = (
                    <Box>
                        <Typography className={styles.tableValue}>
                            {row?.segment ?? '-'}
                        </Typography>
                    </Box>
                );
                break;
            case 'startTime':
                compValue = (
                    <Box>
                        <Typography className={clsx(styles.tableValue)}>
                            {FormatTime(row?.startTime ?? '')}
                        </Typography>
                    </Box>
                );
                break;
            case 'endTime':
                compValue = (
                    <Box>
                        <Typography className={clsx(styles.tableValue)}>
                            {FormatTime(row?.endTime ?? '')}
                        </Typography>
                    </Box>
                );
                break;
            case 'earningsPerHr':
                compValue = (
                    <Box
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'flex-start'}
                        justifyContent={'flex-start'}
                    >
                        <Typography className={clsx(styles.tableValue)}>
                            {formatCurrencyV1(
                                convertRStoAmount(`${row?.minEarnings ?? 0}`),
                                currencyFormatWithoutDecimal,
                            )}
                            {' - '}
                            {formatCurrencyV1(
                                convertRStoAmount(`${row?.maxEarnings ?? 0}`),
                                currencyFormatWithoutDecimal,
                            )}
                        </Typography>
                        {row?.slotType == 'PEAK' && (
                            <Box
                                ml={1}
                                className={clsx([
                                    commonStyles.chip,
                                    chipOrderClass,
                                ])}
                            >
                                <Typography
                                    component={'span'}
                                    className={commonStyles.chipText}
                                >
                                    {row?.slotType ?? '-'}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                );
                break;

            case 'staffCount':
                compValue = row?.capacity ? (
                    <Box
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'flex-start'}
                        justifyContent={'flex-start'}
                    >
                        <Typography className={clsx(styles.tableValue)}>
                            <span
                                style={{
                                    color:
                                        row?.staffCount < row?.capacity
                                            ? '#F44336'
                                            : '#14112D',
                                    fontWeight: 700,
                                }}
                            >{`${row?.staffCount ?? 0}`}</span>
                            {`/${row?.capacity ?? 0}`}
                        </Typography>
                    </Box>
                ) : (
                    '-'
                );
                break;

            case 'action':
                compValue = (
                    <Box
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                        justifyContent={'flex-end'}
                    >
                        <SlotIcon
                            variant="outlined"
                            color="primary"
                            useButton={true}
                            style={{
                                fontSize: 14,
                                fontWeight: 600,
                                marginRight: 8,
                                borderColor: '#EFEFEF',
                                backgroundColor: '#EFEFEF',
                            }}
                            onClick={async () => {
                                openDetailModalHandler(row);
                            }}
                        >
                            View Staffs
                        </SlotIcon>
                        {!!slotList?.capacityApprovalEnabled && (
                            <SlotIcon
                                variant="outlined"
                                color="primary"
                                useButton={true}
                                style={{
                                    fontSize: 14,
                                    fontWeight: 600,
                                    marginRight: 8,
                                    borderColor: '#EFEFEF',
                                    backgroundColor: '#EFEFEF',
                                }}
                                onClick={(event: any) => {
                                    event.stopPropagation();
                                    openEditCapacityModalHandler(row);
                                }}
                            >
                                Edit Capacity
                            </SlotIcon>
                        )}
                        {/* <SlotIcon
                            style={{
                                marginRight: 8,
                                borderRadius: 8,
                                padding: 6,
                            }}
                            color="primary"
                            onClick={(event: any) => {
                                event.stopPropagation();
                            }}
                        >
                            <EditIcon fontSize="small" />
                        </SlotIcon> */}
                        {/* <SlotIcon
                            style={{
                                marginRight: 8,
                                borderRadius: 8,
                                padding: 6,
                            }}
                            color="error"
                            isDelete={true}
                            onClick={(event: any) => {
                                event?.stopPropagation();
                            }}
                        >
                            <DeleteIcon fontSize="small" />
                        </SlotIcon> */}
                    </Box>
                );
                break;

            default:
                break;
        }
        return compValue;
    };

    const handleSingleRidersPage = (rider: any) => {};

    const prepareFilterOptions = () => {
        return [];
    };

    const classStatus: any = replaceWithUnderscore(teamLeadDetails?.status)
        ?.toUpperCase()
        ?.trim();
    let chipClass: any =
        commonStyles?.[`${CM_STATUS_TYPES_MAPPING?.[classStatus]}`];
    let loginClass: any =
        classStatus === 'SIGNED_IN'
            ? commonStyles.activeTxt
            : styles.tableValue;
    return {
        user,
        isLoading,
        styles,
        activeFilterCard,
        prepareFilterCard,
        containerRef,
        prepareFilterOptions,
        searchTextValue,
        filterValues,
        onFilterApplied,
        pagination,
        handleChangePage,
        handleChangeRowsPerPage,
        onBackendSearch,
        onSearchTextChange,
        onRemoveAll,
        getColumnComponentValue,
        handleActiveFilterCard,
        teamLeadDetails,
        chipClass,
        commonStyles,
        loginClass,
        permissions: getPermissions('settings'),
        handleRowClick,
        tlAttendanceModalOpen,
        slotList,
        openDetailModal,
        selectedRow,
        closeDetailModalHandler,
        openEditCapacityModal,
        selectedCapacityRow,
        closeEditCapacityModalHandler,
        openDetailModalHandler,
        fetchSlotsData,
        setFilterValues,
        currentOrgId,
        isBBNowVendor,
    };
};

export default useSlotList;
